import styled from 'styled-components';

// 容器样式
export const ChatInvitationBody = styled.div`
  position: fixed;
  z-index: 1000;
  max-width: 280px;
`;
export const ChatCloseButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
`;
export const ChatCloseButton = styled.div`
  cursor: pointer;
  /*display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) => props.$chatServiceColor ?? '#3F5773'};
  img {
    width: 16px;
    height: 16px;
  }*/
`;
export const ChatMessageContainer = styled.div`
  margin-bottom: 10px;
  background-color: ${(props) => props.$chatservicecolor ?? '#F5EFF8'};
  border-color: ${(props) => props.$chatmessagecolor ?? '#F5EFF8'};
  border-radius: 3px 8px 8px 8px;
  border-width: 1px;
  border-style: solid;
  padding: 4px 8px;
  box-sizing: border-box;

  color: #333333;
  font-size: 12px;
  cursor: pointer;
`;
export const ChatBeginButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const ChatBeginButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;

  background-color: ${(props) => props.$themecolor ?? '#3F5773'};
  outline: none;
  font-weight: bold;
  border-radius: 4px;
  //padding: 10px;
  padding: 5px 12px 5px 12px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
`;
